// @ts-strict-ignore
import { Component, OnInit } from "@angular/core";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import { DataService } from "src/app/shared/services/data.service";

@Component({
  selector: C.EWIZ_USIM_SERVICE_TABLE_CONFIGURATION,
  templateUrl: "./usim-service-table-configuration.component.html",
  standalone: false
})
export class EWizUSIMServiceTableConfigurationComponent extends EWizDynamicBaseClassComponent implements OnInit {
  constructor(private dataService: DataService) {
    super();
  }

  private readonly services = [
    { title: "Local Phone Book", tooltip: "" },
    {
      title: "Fixed Dialing Numbers (FDN)",
      tooltip: "This entry cannot be toggled directly, it is set automatically from Regulatory eCall Support configuration."
    },
    { title: "Extension 2", tooltip: "" },
    {
      title: "Service Dialing Numbers (SDN)",
      tooltip: "This entry cannot be toggled directly, it is set automatically from Regulatory eCall Support configuration."
    },
    { title: "Extension 3", tooltip: "" },
    { title: "Barred Dialing Numbers (BDN)", tooltip: "" },
    { title: "Extension 4", tooltip: "" },
    { title: "Outgoing Call Information (OCI and OCT)", tooltip: "" },
    { title: "Incoming Call Information (ICI and ICT)", tooltip: "" },
    { title: "Short Message Storage (SMS)", tooltip: "" },
    { title: "Short Message Status Reports (SMSR)", tooltip: "" },
    { title: "Short Message Service Parameters (SMSP)", tooltip: "" },
    { title: "Advice of Charge (AoC)", tooltip: "" },
    { title: "Capability Configuration Parameters 2 (CCP2)", tooltip: "" },
    { title: "Cell Broadcast Message Identifier", tooltip: "" },
    { title: "Cell Broadcast Message Identifier Ranges", tooltip: "" },
    {
      title: "Group Identifier Level 1",
      tooltip: "This entry cannot be toggled directly, it is set automatically from GID1 / GID2 configuration."
    },
    {
      title: "Group Identifier Level 2",
      tooltip: "This entry cannot be toggled directly, it is set automatically from GID1 / GID2 configuration."
    },
    { title: "Service Provider Name", tooltip: "" },
    { title: "User controlled PLMN selector with Access Technology", tooltip: "" },
    { title: "MSISDN", tooltip: "" },
    { title: "Image (IMG)", tooltip: "" },
    { title: "Support of Localised Service Areas (SoLSA)", tooltip: "" },
    { title: "Enhanced Multi-Level Precedence and Pre-emption Service", tooltip: "" },
    { title: "Automatic Answer for eMLPP", tooltip: "" },
    { title: "RFU", tooltip: "" },
    { title: "GSM Access", tooltip: "" },
    { title: "Data download via SMS-PP", tooltip: "" },
    { title: "Data download via SMS-CB", tooltip: "" },
    { title: "Call Control by USIM", tooltip: "" },
    { title: "MO-SMS Control by USIM", tooltip: "" },
    { title: "RUN AT COMMAND command", tooltip: "" },
    { title: "Shall be set to '1'", tooltip: "" },
    {
      title: "Enabled Services Table",
      tooltip: "This entry cannot be toggled directly, it is set automatically from Regulatory eCall Support configuration."
    },
    { title: "APN Control List (ACL)", tooltip: "" },
    { title: "Depersonalization Control Keys", tooltip: "" },
    { title: "Co-operative Network List", tooltip: "" },
    { title: "GSM security context", tooltip: "" },
    { title: "CPBCCH Information", tooltip: "" },
    { title: "Investigation Scan", tooltip: "" },
    { title: "MexE", tooltip: "" },
    { title: "Operator controlled PLMN selector with Access Technology", tooltip: "" },
    { title: "HPLMN selector with Access Technology", tooltip: "" },
    { title: "Extension 5", tooltip: "" },
    { title: "PLMN Network Name", tooltip: "" },
    { title: "Operator PLMN List", tooltip: "" },
    { title: "Mailbox Dialing Numbers", tooltip: "" },
    { title: "Message Waiting Indication Status", tooltip: "" },
    { title: "Call Forwarding Indication Status", tooltip: "" },
    { title: "Reserved and shall be ignored", tooltip: "" },
    { title: "Service Provider Display Information", tooltip: "" },
    { title: "Multimedia Messaging Service (MMS)", tooltip: "" },
    { title: "Extension 8", tooltip: "" },
    { title: "Call control on GPRS by USIM", tooltip: "" },
    { title: "MMS User Connectivity Parameters", tooltip: "" },
    { title: "Network's indication of alerting in the MS (NIA)", tooltip: "" },
    { title: "VGCS Group Identifier List (EFVGCS and EFVGCSS)", tooltip: "" },
    { title: "VBS Group Identifier List (EFVBS and EFVBSS)", tooltip: "" },
    { title: "Pseudonym", tooltip: "" },
    { title: "User Controlled PLMN selector for I-WLAN access", tooltip: "" },
    { title: "Operator Controlled PLMN selector for I-WLAN access", tooltip: "" },
    { title: "User controlled WSID list", tooltip: "" },
    { title: "Operator controlled WSID list", tooltip: "" },
    { title: "VGCS security", tooltip: "" },
    { title: "VBS security", tooltip: "" },
    { title: "WLAN Reauthentication Identity", tooltip: "" },
    { title: "Multimedia Messages Storage", tooltip: "" },
    { title: "Generic Bootstrapping Architecture (GBA)", tooltip: "" },
    { title: "MBMS security", tooltip: "" },
    { title: "Data download via USSD and USSD application mode", tooltip: "" },
    {
      title: "Equivalent HPLMN",
      tooltip: "This entry cannot be toggled directly, it is set automatically from Equivalent Home PLMN configuration."
    },
    { title: "Additional TERMINAL PROFILE after UICC activation", tooltip: "" },
    { title: "Equivalent HPLMN Presentation Indication", tooltip: "" },
    { title: "Last RPLMN Selection Indication", tooltip: "" },
    { title: "OMA BCAST Smart Card Profile", tooltip: "" },
    { title: "GBA-based Local Key Establishment Mechanism", tooltip: "" },
    { title: "Terminal Applications", tooltip: "" },
    { title: "Service Provider Name Icon", tooltip: "" },
    { title: "PLMN Network Name Icon", tooltip: "" },
    { title: "Connectivity Parameters for USIM IP connections", tooltip: "" },
    { title: "Home I-WLAN Specific Identifier List", tooltip: "" },
    { title: "I-WLAN Equivalent HPLMN Presentation Indication", tooltip: "" },
    { title: "I-WLAN HPLMN Priority Indication", tooltip: "" },
    { title: "I-WLAN Last Registered PLMN", tooltip: "" },
    { title: "EPS Mobility Management Information", tooltip: "" },
    { title: "Allowed CSG Lists and corresponding indications", tooltip: "" },
    { title: "Call control on EPS PDN connection by USIM", tooltip: "" },
    { title: "HPLMN Direct Access", tooltip: "" },
    {
      title: "eCall Data",
      tooltip: "This entry cannot be toggled directly, it is set automatically from Regulatory eCall Support configuration."
    },
    { title: "Operator CSG Lists and corresponding indications", tooltip: "" },
    { title: "Support for SM-over-IP", tooltip: "" },
    { title: "Support of CSG Display Control", tooltip: "" },
    { title: "Communication Control for IMS by USIM", tooltip: "" },
    { title: "Extended Terminal Applications", tooltip: "" },
    { title: "Support of UICC access to IMS", tooltip: "" },
    { title: "Non-Access Stratum configuration by USIM", tooltip: "" },
    { title: "PWS configuration by USIM", tooltip: "" },
    { title: "RFU", tooltip: "" },
    { title: "URI support by UICC", tooltip: "" },
    { title: "Extended EARFCN support", tooltip: "" },
    { title: "ProSe", tooltip: "" },
    { title: "USAT Application Pairing", tooltip: "" },
    { title: "Media Type support", tooltip: "" },
    { title: "IMS call disconnection cause", tooltip: "" },
    { title: "URI support for MO SHORT MESSAGE CONTROL", tooltip: "" },
    { title: "ePDG configuration Information support", tooltip: "" },
    { title: "ePDG configuration Information configured", tooltip: "" },
    { title: "ACDC support", tooltip: "" },
    { title: "Mission Critical Services", tooltip: "" },
    { title: "ePDG configuration Information for Emergency Service support", tooltip: "" },
    { title: "ePDG configuration Information for Emergency Service configured", tooltip: "" },
    { title: "eCall Data over IMS", tooltip: "" },
    { title: "URI support for SMS-PP DOWNLOAD as defined in 3GPP TS 31.111", tooltip: "" },
    { title: "From Preferred", tooltip: "" },
    { title: "IMS configuration data", tooltip: "" },
    { title: "TV configuration", tooltip: "" },
    { title: "3GPP PS Data Off", tooltip: "" },
    { title: "3GPP PS Data Off Service List", tooltip: "" },
    { title: "V2X", tooltip: "" },
    { title: "XCAP Configuration Data", tooltip: "" },
    { title: "EARFCN list for MTC/NB-IOT UEs", tooltip: "" },
    { title: "5GS Mobility Management Information", tooltip: "" },
    { title: "5G Security Parameters", tooltip: "" },
    { title: "Subscription identifier privacy support", tooltip: "" },
    { title: "SUCI calculation by the USIM", tooltip: "" },
    { title: "UAC Access Identities support", tooltip: "" },
    { title: "Control plane-based steering of UE in VPLMN", tooltip: "" },
    { title: "Call control on PDU Session by USIM", tooltip: "" },
    { title: "5GS Operator PLMN List", tooltip: "" },
    { title: "Support for SUPI of type network specific identifier", tooltip: "" },
    { title: "3GPP PS Data Off separate Home and Roaming lists", tooltip: "" }
  ];

  public usimToService = new Map<string, { title: string; tooltip: string }>();

  disable112 = false;

  ngOnInit() {
    this.profileValues.usimServiceTableVisited = true;
    if (+this.profileValues.regulatoryECallSupport?.supportECall === 0) {
      this.disable112 = true;
    }
    Object.keys(this.profileValues?.usimServiceTable || {})?.forEach((key, i) => this.usimToService.set(key, this.services[i]));
    this.handleFormEvents();
  }

  preserveOrder = () => {
    return 0;
  };
}
